module.exports = __webpack_public_path__ + "static/media/user.33cdab23.svg";